<template>
    <div class="create-smartwatch">
        <form-component ref="form" class="new-smartwatch-page container" v-if="!smartwatchUpdated">
            <div class="row">
                <div class="col">
                    <div class="box">
                        <h4>Smartwatchgegevens</h4>
                        <p class="errorMessage" v-if="smartwatchToEdit.connected">Smartwatch is op dit moment gekoppeld aan een cliënt, wijzigen niet mogelijk.</p>
                        <p v-if="smartwatchNameErrorMessage" class="errorMessage">{{ smartwatchNameErrorMessage }}</p>
                        <input-component
                                label="Smartwatch identificatiecode"
                                v-model="smartwatchToEdit.smartwatchName"
                                :disabled="smartwatchToEdit.connected">
                        </input-component>
                        <p v-if="smartwatchTypeErrorMessage" class="errorMessage">{{ smartwatchTypeErrorMessage }}</p>
                        <input-component
                                label="Smartwatch type"
                                v-model="smartwatchToEdit.smartwatchType"
                                :disabled="smartwatchToEdit.connected">
                        </input-component>
                        <p v-if="uniqueNumberErrorMessage" class="errorMessage">{{ uniqueNumberErrorMessage }}</p>
                        <input-component
                                label="Uniek nummer"
                                v-model="smartwatchToEdit.deviceUniqueNumber"
                                :disabled="smartwatchToEdit.connected">
                        </input-component>
                        <p v-if="phoneNumberErrorMessage" class="errorMessage">{{ phoneNumberErrorMessage }}</p>
                        <input-component
                                label="Telefoonnummer"
                                v-model="smartwatchToEdit.phoneNumber"
                                :disabled="smartwatchToEdit.connected">
                        </input-component>
                        <p v-if="smartwatchLocationErrorMessage" class="errorMessage">{{ smartwatchLocationErrorMessage }}</p>
                        <label for="location">Woonlocatie</label>
                        <select
                                id="location"
                                class="form-control"
                                v-model="smartwatchToEdit.location"
                                :disabled="smartwatchToEdit.connected">
                            <option value=""></option>
                            <option v-for="location in getAllLocations" :value="location" :key="location.id">
                                {{ location.locationName }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <button-component
                    @click.native="updateSmartwatch"
                    v-if="!smartwatchToEdit.connected">
                Opslaan
            </button-component>
            <button-component
                    v-if="!smartwatchToEdit.connected"
                    variant="error"
                    @click.native="showModal">
                Verwijderen
            </button-component>
        </form-component>

        <div class="smartwatch-created" v-if="smartwatchUpdated">
            <div class="complete-image"></div>
            <p class="complete-title">Smartwatch {{ this.smartwatchToEdit.smartwatchName }} gewijzigd, u wordt teruggestuurd naar het overzicht</p>
            <circle-component position="bottom-center" height=236 />
        </div>

        <Modal v-show="isModalVisible"
               @close="closeModal"
               v-bind:header="modalHeaderText"
               v-bind:body="modalBodyText"
               v-bind:buttonLeft="modalButtonLeft"
               v-bind:buttonRight="modalButtonRight"
               @onDeleteClicked="deleteSmartwatch"
        >
        </Modal>
    </div>
</template>

<script>
import { RouteName, Viewport } from '../../utils/enums';
import ListitemComponent from '../../components/listitem.component';
import ButtonComponent from '../../components/button.component.vue';
import FormComponent from '../../components/fields/form.component.vue';
import InputComponent from '../../components/fields/input.component.vue';
import CircleComponent from '../../components/circle.component';
import Modal from '../../components/modal.component.vue';
import { mapGetters } from 'vuex';
import { Smartwatch } from "../../domain/smartwatch";
import { isValidPhoneNumber } from '../../utils/validators';

export default {
    name: 'admin-edit-smartwatch-page',
    components: {
        FormComponent,
        InputComponent,
        ButtonComponent,
        CircleComponent,
        Modal
    },
    data() {
        return {
            smartwatchToEdit: Smartwatch,
            smartwatchUpdated: false,
            smartwatchNameErrorMessage: null,
            smartwatchTypeErrorMessage: null,
            uniqueNumberErrorMessage: null,
            phoneNumberErrorMessage: null,
            smartwatchLocationErrorMessage: null,
            modalHeaderText: 'Smartwatch verwijderen',
            modalBodyText: 'Weet u zeker dat u de smartwatch wilt verwijderen?',
            modalButtonLeft: 'Annuleren',
            modalButtonRight: 'Verwijderen',
            isModalVisible: false
        };
    },
    created() {
        this.$store.dispatch('FETCH_ALL_LOCATIONS');
        this.smartwatchToEdit = this.$store.getters.getSmartwatchToEdit;
    },
    computed: {
        ...mapGetters(['getAllLocations']),
    },
    methods: {
        formIsValid() {
            !this.smartwatchToEdit.smartwatchName ? this.smartwatchNameErrorMessage = 'Identificatiecode is verplicht' : this.smartwatchNameErrorMessage = null;
            !this.smartwatchToEdit.smartwatchType ? this.smartwatchTypeErrorMessage = 'Type is verplicht' : this.smartwatchTypeErrorMessage = null;
            !this.smartwatchToEdit.deviceUniqueNumber ? this.uniqueNumberErrorMessage = 'Uniek nummer is verplicht' : this.uniqueNumberErrorMessage = null;
            !this.smartwatchToEdit.location ? this.smartwatchLocationErrorMessage = 'Woonlocatie is verplicht' : this.smartwatchLocationErrorMessage = null;
            !isValidPhoneNumber(this.smartwatchToEdit.phoneNumber) ? this.phoneNumberErrorMessage = 'Telefoonnummer is niet geldig (0031)' : this.phoneNumberErrorMessage = null;

            return !this.smartwatchNameErrorMessage &&
                !this.smartwatchTypeErrorMessage &&
                !this.uniqueNumberErrorMessage &&
                !this.phoneNumberErrorMessage &&
                !this.smartwatchLocationErrorMessage;
        },
        updateSmartwatch() {
            if (this.formIsValid() && !this.buttonDisabled) {
                this.$store.dispatch('UPDATE_SMARTWATCH', this.smartwatchToEdit)
                    .then(response => {
                        if (response.status === 200) {
                            this.smartwatchUpdated = true; // redirect back after 2 seconds
                            setTimeout(() => {
                                this.$router.push({ name: RouteName.ADMIN_SMARTWATCHES });
                            }, 2500);
                        }
                    })
                    .catch(error => {
                        console.error(error);
                    });
            }
            else {
                console.error('Niet alle velen zijn juist ingevoerd');
            }
        },
        deleteSmartwatch: function () {
            this.closeModal();
            this.$store.dispatch('DELETE_SMARTWATCH', this.smartwatchToEdit.id)
                .then(response => {
                    if (response.status === 200) {
                        this.$router.push({ name: RouteName.ADMIN_SMARTWATCHES });
                    }
                    else {
                        console.error(response);
                    }
                });
        },
        showModal() {
            this.isModalVisible = true;
        },
        closeModal() {
            this.isModalVisible = false;
        }
    }
};
</script>

<style scoped lang="scss">
    .row {
        flex-direction: column;

        @include desktop {
            flex-direction: row;
        }
    }

    .box {
        margin-bottom: 2rem;

        @include desktop {
            background-color: $white;
            // height: 100%;
            padding: 1rem;
            box-shadow: 0 -2px 8px 0px rgba(0, 0, 0, 0.1);
            border-radius: 0.25rem;
        }

        h4 {
            font-weight: 400;
            margin-bottom: 1rem;
            color: $gray-darkest;
        }

        .errorMessage {
            color: $error;
            font-size: 12px;
            font-weight: normal;
            margin-bottom: 0;
        }

        p {
            color: $gray-dark;
        }
    }

    .subtitle {
        margin: 1rem 0;
        display: block;
        font-weight: 500;
    }

    .seperator {
        margin: 2rem 0;
        background-color: $gray;
    }

    .input-component,
    .switch-component {
        margin-bottom: 1rem;
    }

    .row-wrapper {
        display: flex;

        .input-component {
            flex-grow: 1;

            &:first-child {
                margin-right: 60px;
            }
        }
    }

    .smartwatch-bg-color {
        margin-bottom: 1rem;
    }
    .smartwatch-created {
        height: 100%;
        background-color: $primary;
        color: $white;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .complete-title {
            margin-bottom: 14px;
        }

        p {
            font-size: 16px;
            text-align: center;
        }
    }

    .complete-image {
        width: 95px;
        height: 120px;
        background-image: url('../../assets/icons/watch-large-complete.svg');
        margin-bottom: 64px;
        margin-top: -60px;
    }
    .error {
        color: red !important;
    }
    select {
        width: 100%;
        border: 1px solid $gray;
        border-radius: 3px;
        height: 52px;
        padding: 1rem;

        &:hover {
            cursor: pointer;
        }
    }
    label {
        color: $gray-dark;
    }
</style>
